import { get } from "../../../Services/http";
import { catchError } from "../../../Actions/Error.action";

export const INVESTMENT_PAGE_RECEIVE = "INVESTMENT_PAGE_RECEIVE";
export const INVESTMENT_PAGE_ERROR = 'INVESTMENT_PAGE_ERROR';

export const fetchNewsModel = () => (dispatch) => {
    return get('/api/investmentPage/')
        .then(response => response.json())
        .then(result => dispatch(receive(result)))
        .catch(ex => dispatch(catchError(ex, error => setError(error))));
}

export const receive = result => ({
    type: INVESTMENT_PAGE_RECEIVE,
    payload: result
})

export const setError = error => ({
    type: INVESTMENT_PAGE_ERROR,
    payload: {
        error,
    },
})